import ImageModal from './react-image-lightbox';
import PropTypes from 'prop-types';

ImageModal.propTypes = {
  mainSrc: PropTypes.string.isRequired,
  onCloseRequest: PropTypes.func
}

export default ImageModal;
